import { useQuery } from '@tanstack/react-query';
import reviewServices from '../services/review.service';

const parseApiError = (error) => ({
  message:
    error?.response?.data?.message ||
    error?.message ||
    'Something went wrong',

  status:
    error?.response?.status || 500,
});

export const useReviews = ({
  page = 1,
  limit = 10,
  search,
  userType,
  rating,
   sortBy = 'ratedAt',
  sortOrder = 'desc',
} = {}) => {
  return useQuery({
    queryKey: [
      'reviews',
      {
        page,
        limit,
        search,
        userType,
        rating,
        sortBy,
    sortOrder,
      },
    ],

    queryFn: async () => {
      try {
        const params = {
          page,
          limit,

          ...(search && { search }),
          ...(userType && { userType }),
          ...(rating && { rating }),
           ...(sortBy && { sortBy }),
  ...(sortOrder && { sortOrder }),
        };

        return await reviewServices.getReviews(
          params
        );
      } catch (error) {
        throw parseApiError(error);
      }
    },

    staleTime: 30000,

    gcTime: 300000,

    placeholderData: (prev) => prev,

    retry: 1,

    refetchOnWindowFocus: true,
  });
};